import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { ConfirmService } from 'src/app/core/services/confirm.service';

@Component({
  selector: 'app-entity-import',
  templateUrl: './entity-import.component.html',
  styles: [
  ]
})
export class EntityImportComponent implements OnInit {
  @ViewChild(NgForm) importForm!: NgForm;

  parents: ImportParentSummary[] = [];
  submitAttempt: boolean = false;
  connString: string = null;
  doSourceUpdate: boolean = false;
  disableUsers: boolean = true;
  environments: ImportEnvironment[] = [];
  hasParent: boolean = false;

  constructor(private ajax: ajaxCall,
    private confirmService: ConfirmService,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.ajax.MakeCall<ImportEnvironment[]>('/Import/Environments', null).then((data) => {
      this.environments = data;
    }, () => { });
  }

  getParents(): void {
    this.parents = [];
    this.ajax.MakeCall<ImportParentSummary[]>('/Import/Parents', { connString: this.connString }).then((data) => {
      this.parents = data;
      this.hasParent = false;
    }, () => { });
  }

  updateParents(): void {
    this.hasParent = this.parents.filter((x) => x.doImport).length > 0;
    console.log(this.hasParent);
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  doImport(): void {
    this.ajax.MakeCall('/Import/Schedule', { connString: this.connString, parentAccounts: this.parents.filter((x) => x.doImport), doSourceUpdate: this.doSourceUpdate, disableUsers: this.disableUsers }).then((data) => {
      this.modal.close();
    }, () => { });
  }

  import(): void {
    this.submitAttempt = true;
    if (this.importForm.invalid || !this.hasParent) {
      return;
    }
    if (this.doSourceUpdate) {
      this.confirmService.confirm('Confirm Import', 'Are you sure that you want to update the source environment following this import?', 'Yes', 'No').then(() => {
        this.doImport();
      });
    } else {
      this.doImport();
    }

  }
}

class ImportEnvironment {
  connString: string;
  connName: string;
}

class ImportParentSummary {
  parentId: number;
  parentName: string;
  doImport: boolean;
}